var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "esign-popup-provider",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.title,
      closeOnClickOverlay: false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _vm.step === 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "flex-column",
                          on: { change: _vm.onProviderSelected },
                          model: {
                            value: _vm.tempProviderSelected.id,
                            callback: function($$v) {
                              _vm.$set(_vm.tempProviderSelected, "id", $$v)
                            },
                            expression: "tempProviderSelected.id"
                          }
                        },
                        _vm._l(_vm.providers, function(provider, key) {
                          return _c(
                            "el-radio",
                            {
                              key: provider.id,
                              ref: provider.id,
                              refInFor: true,
                              staticClass: "flex-row ai-center",
                              class:
                                key !== _vm.providers.length - 1 ? "mb-4" : "",
                              attrs: { label: provider.id }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "flex-row ai-center" },
                                [
                                  _vm.providerSelected.name
                                    ? _c("SaasIcon", {
                                        staticClass: "provider-icon ml-3",
                                        attrs: {
                                          icon:
                                            provider.name === "Sellsy"
                                              ? "sellsyCloud"
                                              : "docusign",
                                          height: "40",
                                          width: "40"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "semibold fs-3 ml-2 gray-100 lh-20"
                                    },
                                    [_vm._v(_vm._s(provider.name))]
                                  ),
                                  _vm._v(" "),
                                  provider.id === _vm.providersIds.sellsy
                                    ? _c(
                                        "CompassTag",
                                        { attrs: { size: "small" } },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t.__(
                                                  "common.labels.by_default"
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2
                ? _c("div", { ref: "contentStep2" }, [
                    _vm.isConnected
                      ? _c("div", { staticClass: "alert alert-warning" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Vous vous apprêtez à changer de service. En déconnectant votre compte Docusign, le service de signature électronique Sellsy sera réactivé par défaut. Attention, si vous avez des signatures en cours d’envoi, elles ne pourront pas être finalisées par vos destinataires."
                                )
                              ) +
                              "\n                "
                          )
                        ])
                      : _c("div", { staticClass: "alert alert-warning" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Vous vous apprêtez à changer de service. Toutes les prochaines signatures électronique seront désormais envoyées par Docusign. Vous pouvez toujours revenir à l’ancien service."
                                )
                              ) +
                              "\n                "
                          )
                        ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("preloader", { attrs: { display: _vm.loading } })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary",
                    size: "medium"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  ref: "continueBtn",
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.submitBtnText,
                    type: "primary",
                    size: "medium",
                    disabled: _vm.submitBtnDisabled
                  },
                  on: { click: _vm.onClickContinue }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }